import './sentry';
import './meta-pixel';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from '@/contexts/AuthContext';
import { UserStatusProvider } from '@/contexts/UserStatusContext';
import { LanguageProvider } from '@/contexts/LanguageContext';
import { OnboardingProvider } from '@/contexts/OnboardingContext';
import OnboardingOverlay from '@/components/onboarding/OnboardingOverlay';
import { ErrorBoundary } from '@/components/ErrorBoundary';
import './index.css';
import App from './App';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <UserStatusProvider>
          <LanguageProvider>
            <OnboardingProvider>
              <ErrorBoundary>
                <App />
                <OnboardingOverlay />
              </ErrorBoundary>
            </OnboardingProvider>
          </LanguageProvider>
        </UserStatusProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
